import { h, Component } from 'preact';
import { route } from 'preact-router';
import { BaseComponent } from '../../common/BaseComponent';
import TextField from 'preact-material-components/TextField';
import Button from 'preact-material-components/Button';
import List from 'preact-material-components/List';
import { IWorkRequestProps, IWorkRequestState } from './IWorkRequestComponent';
import { bind } from 'decko';
import { SaveWorkrequestRequest } from '../../models/SaveWorkrequestRequest';
import Files from 'react-files'
import { UploadFileForWorkrequestRequest } from '../../models/UploadFileForWorkrequestRequest';

import { VideoPlayer } from '../../components/videoPlayer/videoPlayer'
import { DocViewer } from '../../components/docViewer/docViewer';
import { DocType } from '../../enums/DocType';

let style = require('./style.scss');

export class WorkRequestComponent extends BaseComponent<IWorkRequestProps, IWorkRequestState> {

    constructor(props, ctx) {
        super(props, ctx);
        this.setState({
            note: ""
        });
    }

    private fixNewLine(str: string) {
        return str.split('\n').map((item, key) => {
            return <span key={'' + key}>{item}<br /></span>
        });
    }

    @bind
    public onChangeStatus(status: string) {
        this.modal.showLoader(this.buildingService.saveWorkrequest(new SaveWorkrequestRequest({
            buildingId: this.props.buildingId,
            notes: this.state.note,
            workrequestId: this.props.workRequest.id,
            status: status
        })))
            .then(r => {
                if (r.infoMessage)
                    this.modal.alert(r.infoMessage, () => {
                        if (!r.errorMessage) {
                            this.props.onRefresh();
                        }
                    });
                else if (r.errorMessage) {
                    this.modal.alert(r.errorMessage);
                }
                else
                    this.props.onRefresh();
            }).catch(e => {
                this.modal.alert(e.errorMessage || e);
            });
    }

    @bind
    public onFilesChange(files: any) {
        var file: File = files[0];
        if (file.name.indexOf(".jpg") > -1 || file.name.indexOf(".jpeg") > -1 || file.name.indexOf(".png") > -1)
            this.scaleImage(file, 2048, 0.5, (f) => { this.uploadFile(f); });
        else
            this.uploadFile(file);
    }

    private uploadFile(file: File) {
        this.modal.showLoader(this.buildingService.uploadFileForWorkrequest(new UploadFileForWorkrequestRequest({
            buildingId: this.props.buildingId,
            workrequestId: this.props.workRequest.id,
            file: new Blob([file], { type: file.type }),
            fileName: file.name
        })))
            .then(r => {
                if (r.errorMessage) {
                    this.modal.alert(r.errorMessage);
                    return;
                }
                this.props.onRefresh();
            }).catch(e => {
                this.modal.alert(e.errorMessage || e);
            });
    }

    private scaleImage(file: File, width, step, callback) {

        var img = new Image();

        img.crossOrigin = "Anonymous";
        img.onload = () => {
            var canvas = document.createElement('canvas'),
                ctx = canvas.getContext("2d"),
                oc = document.createElement('canvas'),
                octx = oc.getContext('2d');
            if (img.width < img.height) {
                width *= img.width / img.height
            }

            canvas.width = width;
            canvas.height = canvas.width * img.height / img.width;

            if (img.width * step > width) {
                var mul = 1 / step;
                var cur = {
                    width: Math.floor(img.width * step),
                    height: Math.floor(img.height * step)
                }

                oc.width = cur.width;
                oc.height = cur.height;

                octx.drawImage(img, 0, 0, cur.width, cur.height);

                while (cur.width * step > width) {
                    cur = {
                        width: Math.floor(cur.width * step),
                        height: Math.floor(cur.height * step)
                    };
                    octx.drawImage(oc, 0, 0, cur.width * mul, cur.height * mul, 0, 0, cur.width, cur.height);
                }

                ctx.drawImage(oc, 0, 0, cur.width, cur.height, 0, 0, canvas.width, canvas.height);
            } else {
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            }

            canvas.toBlob((blob: Blob) => {
                var resizedImageFile = new File([blob], file.name, { type: file.type });
                callback(resizedImageFile);
            }, file.type, 0.9);
            //document.getElementById("stepped").src = canvas.toDataURL();

        }
        img.src = (window as any).URL.createObjectURL(file);

    }
     
    @bind
    public onFilesError() {
        console.log(arguments);
    }

    componentWillMount() {

    }

    componentWillReceiveProps(p) {
        this.setState({ note: "" });
    }


    public isExactLocationImage(): boolean {
        if (this.props.workRequest.exactLocation.indexOf("<img") > -1)
            return true;
        return false;
    }

    public showDocToDisplay(url: string, type: DocType) {
        this.modal.showMessageBox({
            message: this.getDocToDisplay(url, type),
            maxSize: type == DocType.Pdf,
            buttons: [
                {
                    text: "Ok",
                    onClick: () => {

                        if (type == DocType.Pdf)
                            this.refs.doc.destroy();
                        else if (type == DocType.Vimeo)
                            this.refs.video.destroy();

                        this.modal.hideDialog();
                    }
                }
            ]
        });
    }

    public getDocType(url: string): DocType {

        var lurl = url.toLowerCase();
        var imgExtensions = [".bmp", ".jpg", ".jpeg", ".png"];
        if (lurl.endsWith(".pdf"))
            return DocType.Pdf;
        else if (lurl.indexOf("https://vimeo") > -1 || lurl.indexOf(".mp4") > -1)
            return DocType.Vimeo;
        else if (imgExtensions.some((val) => { return lurl.endsWith(val); }))
            return DocType.Image;
        else return DocType.Unknown;
    }

    public getDocToDisplay(url: string, type?: DocType) {
        type = type || this.getDocType(url);
        switch (type) {
            case DocType.Image:
                var f = () => { };
                var p = new Promise((res, rej) => {
                    f = () => { res(); }
                    this.modal.setState(s => { s.options.maxSize = true; return s; });
                });
                this.modal.showLoader(p);
                return <div class={`${style.workRequestImage}`}><img src={url} onLoad={f} /></div>
            case DocType.Pdf:
                return <DocViewer ref={this.setRef("doc")} url={url} />;
            case DocType.Vimeo:
                return <VideoPlayer ref={this.setRef("video")} url={url} playing />
        }
        return null;
    }

    render() {
        return <div class={style.workRequestComponent}>
            {this.props.workRequest && <div>
                <List class={style.workRequestItems} dense>
                    <List.Item><List.PrimaryText>Lodgement Date</List.PrimaryText><List.SecondaryText>{this.props.workRequest.lodgementDate}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Job Code</List.PrimaryText><List.SecondaryText>{this.props.workRequest.jobCode}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Tenant Name</List.PrimaryText><List.SecondaryText>{this.props.workRequest.tenantName}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Level Name</List.PrimaryText><List.SecondaryText>{this.props.workRequest.levelName}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Contact Name</List.PrimaryText><List.SecondaryText>{this.props.workRequest.contactName}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Contact Phone</List.PrimaryText><List.SecondaryText>{this.props.workRequest.contactPhone}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Contact Email</List.PrimaryText><List.SecondaryText>{this.props.workRequest.contactEmail}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item class={`mdc-list-item ${this.isExactLocationImage() ? style.exactLocationImage : ""}`}><List.PrimaryText>Exact Location</List.PrimaryText><List.SecondaryText>{this.isExactLocationImage() ? <span dangerouslySetInnerHTML={{ __html: this.props.workRequest.exactLocation }}></span> : this.props.workRequest.exactLocation}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Details</List.PrimaryText><List.SecondaryText>{this.fixNewLine(this.props.workRequest.details)}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Priority</List.PrimaryText><List.SecondaryText>{this.props.workRequest.priority}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Category</List.PrimaryText><List.SecondaryText>{this.props.workRequest.category}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Type</List.PrimaryText><List.SecondaryText>{this.props.workRequest.type}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Status</List.PrimaryText><List.SecondaryText>{this.props.workRequest.status}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Work Notes</List.PrimaryText><List.SecondaryText>{this.fixNewLine(this.props.workRequest.workNotes)}</List.SecondaryText></List.Item>
                    <List.Divider />
                    <List.Item><List.PrimaryText>Work Notes (Visible To Tenant)</List.PrimaryText><List.SecondaryText>{this.fixNewLine(this.props.workRequest.workNotesVisibleToTenant)}</List.SecondaryText></List.Item>
                    <List.Divider />
                </List>

                <div class={style.attachment}>
                    <label>Attachments</label>
                    <Files
                        onChange={this.onFilesChange}
                        onError={this.onFilesError}
                        multiple={false}
                        /*accepts={['image/png', '.pdf', 'audio/*']}
                        maxFiles={3}
                        maxFileSize={10000000}
                        minFileSize={0}*/
                        clickable
                    >
                        <Button ripple primary ><Button.Icon>attachment</Button.Icon></Button>
                    </Files>
                </div>

                <List>
                    {this.props.workRequest.attachments.map(a => {
                        var type = this.getDocType(a.location);
                        if (type == DocType.Unknown)
                            return <span><List.LinkItem href={a.location} target="_blank"><List.ItemGraphic>insert_drive_file</List.ItemGraphic>{a.name}</List.LinkItem><List.Divider /></span>
                        else
                            return <span><List.Item onClick={() => { this.showDocToDisplay(a.location, type); }} ><List.ItemGraphic>insert_drive_file</List.ItemGraphic>{a.name}</List.Item><List.Divider /></span>
                    })}
                </List>

                <div class={style.formField}>
                    <TextField id="workNotes" name="workNotes" label="Add Work Notes" value={this.state.note} onInput={(e: any) => { this.setState({ note: e.target.value }) }} />
                </div>
                {this.props.actionButtons.map(a => {
                    return <div class={style.formField}>
                        <Button raised ripple onClick={e => this.onChangeStatus(a)}>{a}</Button>
                    </div>
                })}

            </div>}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./components/WorkRequests/WorkRequestComponent.tsx